<header class="v2h-header">
    <div class="v2h-barra">
        <a class="v2h-logo" [routerLink]="['/landing/inicio']" (click)="menuAbierto = false">
            <span class="v2h-logo-circulo"><img src="./assets/logos/logo.png" alt="Liga Yucatán"></span>
            <span class="v2h-logo-texto">
                <span class="v2h-logo-titulo">Liga Infantil y Juvenil</span>
                <span class="v2h-logo-sub">de Béisbol Yucatán A.C.</span>
            </span>
        </a>

        <nav class="v2h-nav">
            <a [routerLink]="['/landing/inicio']" routerLinkActive="v2h-activo" class="v2h-nav-link">Inicio</a>
            <a [routerLink]="['/landing/calendario']" routerLinkActive="v2h-activo" class="v2h-nav-link">Calendario</a>
            <a [routerLink]="['/landing/estadisticas']" routerLinkActive="v2h-activo" class="v2h-nav-link">Estadísticas</a>
            <a [routerLink]="['/landing/resultados-107']" routerLinkActive="v2h-activo" class="v2h-nav-link">Resultados 107</a>
            <a [routerLink]="['/landing/reglas']" routerLinkActive="v2h-activo" class="v2h-nav-link">Reglamento</a>
        </nav>

        <div class="v2h-acciones">
            <button type="button" class="v2h-btn-registro" (click)="openModal(2)">Registrar equipo</button>
            <button type="button" class="v2h-btn-sesion" (click)="openModal(1)"><i class="fas fa-user"></i> Iniciar sesión</button>
            <button type="button" class="v2h-hamburguesa" (click)="menuAbierto = !menuAbierto" aria-label="Menú">
                <i class="fas" [ngClass]="menuAbierto ? 'fa-times' : 'fa-bars'"></i>
            </button>
        </div>
    </div>

    <div class="v2h-movil" [class.abierto]="menuAbierto">
        <a [routerLink]="['/landing/inicio']" (click)="menuAbierto = false" class="v2h-movil-link">Inicio</a>
        <a [routerLink]="['/landing/calendario']" (click)="menuAbierto = false" class="v2h-movil-link">Calendario</a>
        <a [routerLink]="['/landing/estadisticas']" (click)="menuAbierto = false" class="v2h-movil-link">Estadísticas</a>
        <a [routerLink]="['/landing/resultados-107']" (click)="menuAbierto = false" class="v2h-movil-link">Resultados 107</a>
        <a [routerLink]="['/landing/reglas']" (click)="menuAbierto = false" class="v2h-movil-link">Reglamento</a>
        <div class="v2h-movil-acciones">
            <button type="button" class="v2h-btn-registro" (click)="openModal(2); menuAbierto = false">Registrar equipo</button>
            <button type="button" class="v2h-btn-sesion" (click)="openModal(1); menuAbierto = false"><i class="fas fa-user"></i> Iniciar sesión</button>
        </div>
    </div>
</header>

<ng-template #contentLogin let-modal>
    <div class="container-fluid mx-0 py-0" style="background-color: #EDEFF4;">
        <div class="row">
            <div class="col-12 header_mod">
                <a (click)="modal.close()" style="cursor: pointer;" class="active_aunt"><i class="fas fa-times"></i></a>
            </div>
        </div>
        <div class="row justify-content-center pb-4 mt-n5">
            <div class="col-10 body_mod">
                <div class="row justify-content-center mt-n3">
                    <div class="col-3">
                        <img src="./assets/logos/logo.png" class="img-fluid">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <form action="" method="" class="row g-3">
                            <strong class="text-center">LIGA INFANTIL Y JUVENIL DE BEISBOL YUCATAN A.C.</strong>
                            <strong class="text-center">{{temporadaa}}</strong>
                            <div class="col-12">
                                <label>Correo electrónico</label>
                                <input type="text" name="username" class="form-control" placeholder="Username" [(ngModel)]="login.usuario">
                            </div>
                            <div class="col-12">
                                <label>Contraseña</label>
                                <input type="password" name="password" class="form-control" placeholder="Password" [(ngModel)]="login.contra">
                            </div>
                            <div class="col-12">
                                <p class="mb-0" (click)="openModal()">Recupera tu contraseña <a href="#">aquí</a></p>
                            </div>
                            <div class="col-12 text-center">
                                <button class="btn text-white btn-sm" style="background-color: #35AD79;" (click)="Login()">Iniciar sesión</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pb-3">
            <div class="col-12">
                <p class="text-center mb-0"> Aún no has registrado a tu equipo? <a class="text-info" style="cursor: pointer;">Registralo</a></p>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #modalReg let-modalReg>
    <div class="container-fluid mx-0 py-0" style="background-color: #EDEFF4;">
        <div class="row">
            <div class="col-12 header_mod">
                <a (click)="modalReg.close()" style="cursor: pointer;" class="active_aunt"><i class="fas fa-times"></i></a>
            </div>
        </div>
        <div class="row justify-content-center pb-4 mt-n5">
            <div class="col-11 body_mod">
                <div class="row justify-content-center mt-n3">
                    <div class="col-3">
                        <img src="./assets/logos/logo.png" class="img-fluid">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form">
                            <div class="form-row">
                                <div class="col-12 text-center">
                                    <strong class="text-center">REGISTRA A TU EQUIPO</strong>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12">
                                    <mat-tab-group mat-align-tabs="start" >
                                        <mat-tab label="EQUIPO">
                                            <div class="container mt-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="row align-items-center">
                                                            <div class="col-10">
                                                                <label for="formFile" class="form-label">Recibo de pago</label>
                                                                <input class="form-control" type="file" accept=".jpg" (change)="cambiarImagen($event)" name="file">
                                                            </div>
                                                            <div class="col-1 pt-lg-4" style="font-size: 32px;color: #38b44a;">
                                                                <i class="fas fa-camera" (click)="tomarFoto()" style="cursor: pointer;" title="Tomar foto"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 mt-1">
                                                        <label for="formFile" class="form-label">Nombre del equipo</label>
                                                        <input class="form-control" type="text" [(ngModel)]="json.equipo" style="text-transform: uppercase;" name="equipo">
                                                    </div>
                                                    <div class="col-12 mt-2">
                                                        <label for="formFile" class="form-label">Categoria</label>
                                                        <select class="form-select" aria-label="Default select example" [(ngModel)]="json.CategoriaID">
                                        <option selected disabled>Selecciona la categoria del equipo</option>
                                        <option *ngFor="let categoria of categorias" value="{{categoria.CategoriaID}}">{{categoria.Categoria}}</option>
                                      </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </mat-tab>
                                        <mat-tab  label="REPRESENTANTE">
                                            <div class="container mt-2">
                                                <div class="row">
                                                    <div class="col-md-12 col-lg-6 form-group">
                                                        <label for="formFile" class="form-label">CURP</label>
                                                        <input class="form-control" type="text" [(ngModel)]="json.curp" style="text-transform: uppercase;" maxlength="18" required name="curp">
                                                    </div>
                                                    <div class="col-md-12 col-lg-6 form-group">
                                                        <label for="formFile" class="form-label">Telefono</label>
                                                        <input class="form-control" type="text" [(ngModel)]="json.telefono" style="text-transform: uppercase;" maxlength="10" name="telefono">
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-4 col-sm-6 form-group">
                                                        <label for="formFile" class="form-label">Apellido paterno</label>
                                                        <input class="form-control" type="text" [(ngModel)]="json.apellido_p" style="text-transform: uppercase;" required name="apeP">
                                                    </div>
                                                    <div class="col-lg-4 col-sm-6 form-group">
                                                        <label for="formFile" class="form-label">Apellido materno</label>
                                                        <input class="form-control" type="text" [(ngModel)]="json.apellido_m" style="text-transform: uppercase;" required>
                                                    </div>
                                                    <div class="col-lg-4 col-sm-12 form-group">
                                                        <label for="formFile" class="form-label">Nombre (s)</label>
                                                        <input class="form-control" type="text" [(ngModel)]="json.nombres" style="text-transform: uppercase;" required name="apeM">
                                                    </div>
                                                    <div class="col-4 form-group">
                                                        <label for="formFile" class="form-label">Correo</label>
                                                        <input class="form-control" type="text" [(ngModel)]="json.correo" name="correo" required>
                                                    </div>
                                                    <div class="col-4 form-group">
                                                        <label for="formFile" class="form-label">Contraseña</label>
                                                        <input class="form-control" type="password" [(ngModel)]="json.contra" maxlength="50" name="contra" required>
                                                    </div>
                                                    <div class="col-4 form-group">
                                                        <label for="formFile" class="form-label">Repetir contraseña</label>
                                                        <input class="form-control" type="password" name="repit">
                                                    </div>
                                                </div>
                                            </div>
                                        </mat-tab>
                                    </mat-tab-group>
                                </div>
                                <div class="col-12 text-right mt-2">
                                    <button class="btn text-white btn-sm" style="background-color: #35AD79;" (click)="enviar()">Enviar inscripción</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pb-3">
            <div class="col-12">
                <strong class="text-center mb-0">Aviso : Tu solicitud de inscripción será revisada, te llegará un correo de confirmación para que puedas acceder a la plataforma</strong>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #modal_camera let-camera>
    <div class="modal-header">
        <h2 class="modal-title" id="tituloModal">Tomar fotografia</h2>
    </div>
    <div class="modal-body">
        <div class="container">
            <div class="row">
                <div *ngIf="isCameraExist; else noCameraExist" class="col-12">
                    <div class="border border-success rounded text-center" style="width: 100%;height: 265px;">
                        <webcam [height]="450" [width]="350" [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam" [switchCamera]="nextWebcamObservable"></webcam>
                    </div>

                    <div *ngIf="errors.length > 0">
                        <h4>Error Messages:</h4>
                        <ul *ngFor="let error of errors">
                            <li>{{ error | json }}</li>
                        </ul>
                    </div>
                </div>

                <ng-template #noCameraExist>
                    <div class="border border-danger rounded text-center" style="display: flex;justify-content: center;align-items: center;width: 450px;height: 350px;">
                        Este dispositivo no cuenta con una camara disponible
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" (click)="camera.close()">Cerrar</button>
        <button *ngIf="isCameraExist" type="button" class="btn btn-success" (click)="takeSnapshot()">Tomar foto</button>
    </div>
</ng-template>
<ng-template #recuperar let-modalRecupera>
    <div class="modal-header">
        <h2>Recuperación de la contraseña</h2>
    </div>
    <div class="modal-body">
        <div class="container my-2">
            <div class="row">
                <div class="col">
                    <div class="input-group mb-3">
                        <input type="email" [(ngModel)]="correo" class="form-control" placeholder="Ingresa el correo con el que te has registrado" aria-label="Recipient's username" aria-describedby="basic-addon2" required>
                        <div class="input-group-append my-0 py-0">
                            <button class="btn btn-success my-0 py-0" type="button" (click)="recuperarContra()"><i class="fas fa-search"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" [hidden]="mostrarInfo">
                <div class="col-sm-12">
                    <div class="card rounded border border-success w-100" style="width: 18rem;" *ngIf="tipo == 1">
                        <div class="card-body">
                            <h5 class="card-title">Hemos encontrado su cuenta</h5>
                            <h6 class="card-subtitle mb-2 text-muted">Valida la información</h6>
                            <p class="card-text">
                                EQUIPO : {{info.equipo}}
                                <br> REPRESENTANTE : {{info.nombre}}
                                <br> TELEFONO : {{info.telefono}}
                                <br> CORREO : {{info.correo}}
                            </p>
                            <a href="#" class="card-link btn-sm float-right" title="Enviar contraseña a correo" style="font-size: 24px;" (click)="enviarContra(0)"><i class="fas fa-envelope-open-text"></i></a>
                        </div>
                    </div>
                    <div class="card rounded border border-danger w-100" style="width: 18rem;" *ngIf="tipo == 2">
                        <div class="card-body">
                            <h5 class="card-title">Lo sentimos, no hemos encontrado su cuenta</h5>
                            <h6 class="card-subtitle mb-2 text-muted">Sin embargo hemos encontrado coincidencias con el usuario proporcionado</h6>
                            <div class="card-text">
                                <div *ngFor="let con of coincidencias" class="row align-items-center border-bottom">
                                    <div class="col-10">
                                        EQUIPO : {{con.Equipo}}
                                        <br> REPRESENTANTE : {{con.nombre}}
                                        <br> TELEFONO : {{con.TelRep}}
                                        <br> CORREO : {{con.MailRep}}
                                    </div>
                                    <div class="col-2">
                                        <a href="#" class="card-link btn-sm float-right" title="Enviar contraseña a correo" style="font-size: 24px;" (click)="enviarContra(con.UsuarioID)"><i class="fas fa-envelope-open-text"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <small class="text-warning">**IMPORTANTE**  Si el correo no te llega comunicate con el administrador del sistema</small>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-danger" (click)="closeModal(3)"><i class="far fa-times-circle"></i> Cerrar</button>
    </div>
</ng-template>
